import { LOCALES } from 'i18n/locales';

export const myLocationButtonIntl = {
    [LOCALES.ENGLISH]: {
        'myLocationButton.findMe': 'Centre map on my location'
    },
    [LOCALES.WELSH]: {
        'myLocationButton.findMe': 'Canoli\'r map ar fy lleoliad'
    }
};
